 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { useCallback, useEffect, useState } from "react";
import {
    getSocialUserInfo,
    setSocialUserInfo,
    SOCIAL_USER_INFO_KEY,
    SOCIAL_USER_INFO_UPDATED_EVENT,
} from "../../services/user_info_storage";

const useSocialUserInfo = (initialUserInfo) => {
    const [userinfo, setUserinfo] = useState(() => _nullishCoalesce(initialUserInfo, () => ( getSocialUserInfo())));

    useEffect(() => {
        const syncUserInfo = (event) => {
            setUserinfo(_nullishCoalesce(_optionalChain([event, 'optionalAccess', _ => _.detail]), () => ( getSocialUserInfo())));
        };

        const syncFromStorage = (event) => {
            if (event.key === SOCIAL_USER_INFO_KEY) {
                setUserinfo(getSocialUserInfo());
            }
        };

        window.addEventListener(SOCIAL_USER_INFO_UPDATED_EVENT, syncUserInfo);
        window.addEventListener("storage", syncFromStorage);

        return () => {
            window.removeEventListener(SOCIAL_USER_INFO_UPDATED_EVENT, syncUserInfo);
            window.removeEventListener("storage", syncFromStorage);
        };
    }, []);

    const updateUserinfo = useCallback((nextUserInfo) => {
        const resolvedUserInfo =
            typeof nextUserInfo === "function" ? nextUserInfo(getSocialUserInfo()) : nextUserInfo;

        setSocialUserInfo(resolvedUserInfo);
        setUserinfo(resolvedUserInfo);
    }, []);

    return [userinfo, updateUserinfo];
};

export default useSocialUserInfo;
